var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2760_23422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17.25C16.6904 17.25 17.25 16.6904 17.25 16C17.25 15.3096 16.6904 14.75 16 14.75C15.3096 14.75 14.75 15.3096 14.75 16C14.75 16.6904 15.3096 17.25 16 17.25Z",
    fill: "#444A6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.25C11.1904 17.25 11.75 16.6904 11.75 16C11.75 15.3096 11.1904 14.75 10.5 14.75C9.80964 14.75 9.25 15.3096 9.25 16C9.25 16.6904 9.80964 17.25 10.5 17.25Z",
    fill: "#444A6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 17.25C22.1904 17.25 22.75 16.6904 22.75 16C22.75 15.3096 22.1904 14.75 21.5 14.75C20.8096 14.75 20.25 15.3096 20.25 16C20.25 16.6904 20.8096 17.25 21.5 17.25Z",
    fill: "#444A6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2760_23422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/Others.7a685fca9fbbc2a79c4050f7a8de0d73.svg";
export { ForwardRef as ReactComponent };